import { loadStripe, type Stripe } from "@stripe/stripe-js"
import { ref } from "vue"

let initPromise: Promise<[Stripe, Stripe]> | null = null
const initStripe = () => {
  if (!initPromise) {
    initPromise = Promise.all([
      loadStripe(import.meta.env.VITE_APP_STRIPE_EMERALD_KEY),
      loadStripe(import.meta.env.VITE_APP_STRIPE_SAPPHIRE_KEY),
    ]).catch(() => {
      throw new Error("Stripe failed to load")
    })
  }

  return initPromise
}

export const useStripe = () => {
  const error = ref(false)
  const loaded = ref(false)

  const stripe = (isSapphire: boolean): Stripe => {
    if (isSapphire) {
      return stripeSapphire
    }

    return stripeEmerald
  }

  let stripeEmerald: Stripe | null = null
  let stripeSapphire: Stripe | null = null

  const init = async (): Promise<typeof stripe> => {
    await initStripe()
      .then(([emerald, sapphire]) => {
        loaded.value = true
        stripeEmerald = emerald
        stripeSapphire = sapphire
      })
      .catch(() => {
        error.value = true
      })

    return Promise.resolve(stripe)
  }

  return {
    error,
    init,
    loaded,
    stripe,
  }
}
